import Quotes from "../../images/testimonials/quotes.png";
import BoxShape from "../../images/testimonials/testimonial-shape.svg";

function TestimonialBox({ text, name, job, active }) {
  return (
    <div 
      className={`absolute flex flex-col bg-black top-0 right-0 w-[60%] md1000:w-full h-full py-[47px] px-[50px] min540:py-[24px] min540:px-[30px] min540:h-auto min375:h-auto transition-all duration-500 ease-in-out ${
        active ? "opacity-100 z-10 translate-x-0" : "opacity-0 z-0 translate-x-4 pointer-events-none"
      }`}
    >
      <img alt="quote_img" src={Quotes} className="w-[6rem]" />
      <p className="text-[16px] italic text-[#dedede] my-6 z-10 leading-relaxed">{text}</p>
      <div className="flex gap-1 mb-2">
        <i className="fa-solid fa-star text-[#ffc107] text-[18px]"></i>
        <i className="fa-solid fa-star text-[#ffc107] text-[18px]"></i>
        <i className="fa-solid fa-star text-[#ffc107] text-[18px]"></i>
        <i className="fa-solid fa-star text-[#ffc107] text-[18px]"></i>
        <i className="fa-solid fa-star text-[#ffc107] text-[18px]"></i>
      </div>
      <p className="text-[14px] font-medium text-[#dedede]">{job}</p>
      <img
        alt="box_img"
        src={BoxShape}
        className="w-[17.5rem] absolute bottom-0 right-[13.5rem] invert opacity-40 md1000:hidden"
      />
    </div>
  );
}

export default TestimonialBox;
